import { createContext, useContext } from "react";

export type LocalePaths = Record<string, string>;

// Per-page map of locale -> path (without origin or locale prefix), e.g.
// { en: "/product/lynild-large-throw", no: "/product/lynild-store-pledd" }.
// router.push(path, undefined, { locale }) handles the /no prefix itself.
const LocalePathContext = createContext<LocalePaths | null>(null);

export const LocalePathProvider = LocalePathContext.Provider;

export const useLocalePaths = (): LocalePaths | null =>
  useContext(LocalePathContext);
